// extracted by css-extract-rspack-plugin
export default {"container":"container-VWTx5D","icon":"icon-OoEYYs","small":"small-TbyWic","medium":"medium-tvJW8Y","large":"large-zhWDpG"};